import {Component} from '@angular/core'

@Component({
  selector: 'foa-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss']
})
export class AgreementComponent {

}
